import { render, staticRenderFns } from "./importTrans.vue?vue&type=template&id=21250604&"
import script from "./importTrans.vue?vue&type=script&lang=js&"
export * from "./importTrans.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports